import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexBasiccard',
  setup(__props) {

const BasicFlat = defineAsyncComponent(() => import("@/components/theme/advance/basic/BasicFlat.vue"))
const ShadowCard = defineAsyncComponent(() => import("@/components/theme/advance/basic/ShadowCard.vue"))
const IconCard = defineAsyncComponent(() => import("@/components/theme/advance/basic/IconCard.vue"))
const DarkCard = defineAsyncComponent(() => import("@/components/theme/advance/basic/DarkCard.vue"))
const FooterCard = defineAsyncComponent(() => import("@/components/common/FooterCard.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BasicFlat)),
      _createVNode(_unref(ShadowCard)),
      _createVNode(_unref(IconCard)),
      _createVNode(_unref(DarkCard)),
      _createVNode(_unref(FooterCard))
    ])
  ]))
}
}

})